window.onload = function() {
    function decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.textContent = html;
        return txt.textContent;
    }

    const colorMapping = {
        'Dark Chocolate Protein': '#2c1810',
        'Unflavoured': '#EBE4DC',
        'Beetroot & Chocolate': '#6E182D',
        'Chocolate Orange': '#EBA36D',
        'Sicilian': '#F3AB7B',
        'Mixed Flavour Box of 12': '#F27961',
        'Multi Nutrient': '#5c9bbf',
        'Pecan & Cinnamon': '#CB802B',
        'Mixed': '#C61A7E',
        'Matcha': '#74A12E',
        'Hemp Original': '#ABBB9C',
        'Blue': '#8AADBF',
        'Walnut': '#705C5B',
        'Hazelnut': '#95694E',
        'Chocolate': '#8B5D3B',
        'Beetroot': '#96243A',
        'Cherry Bakewell': '#C11543',
        'Pistachio': '#BBCC8E',
        'Almond': '#CF9375',
        'Turmeric': '#E1B468',
        'Strawberry': '#F0797F',
        'Coconut': '#cbc9c6',
        'Macadamia': '#BD9685',
        'Vegan Vanilla': '#E6C98E',
        'Vegan 2.0 Vanilla': '#E6C98E',
        'Banana': '#F5E398',
        'Whey Protein Concentrate': '#EC762F',
        'Sunflower Protein': '#C9A24D',
        'Pea Protein': '#F9D465',
        'Pumpkin Protein': '#ABA057',
        'Blackcurrant': '#695B84',
        'Hemp Protein': '#ABBB9C',
        'Chai': '#dc6d8e',
        'Scoop': '#c0c0c0',
        'Orange & Cranberry': '#c82745',
        'Peach': '#e4b481',
        'Raspberry': '#CB2246',
        'Apple': '#703D5D',
        'Porridge Variety Box': '#2B3E24',
        'Golden Syrup': '#f2a71d',
        'Soup Variety Pack': '#a20067',
        'Red Pepper': '#b81c21',
        'Pumpkin Soup': '#d04012',
        'Soup Variety 12-Pack': '#a20067',
        'Soup Sample Pack': '#a20067',
        'Mushroom': '#85542c',
        'Broccoli': '#45743e',        
        'Haskap': '#4F3E8A',
        'Whey Protein Isolate': '#685d49',
        'Creatine': '#252626',
        'Casein': '#133751',
        'Fava': '#526331',
        'Coconut Wholefood Bars': '#49bdcc',
        'Mixed Berry Wholefood Bars': '#f18ea1',
        'Chocolate Wholefood Bars': '#c1724e',
        'Vanilla Bean Protein': '#9e775b',
        'Ceylon Cinnamon Protein': '#792616',
        'Mocha Protein': '#71432e',
    };

    function setBorderColor() {
        document.querySelectorAll('.product-item .variant-name').forEach(function (variantSpan) {
            const variantName = decodeHtml(variantSpan.textContent.trim());
            let color;
            for (let key in colorMapping) {
                if (variantName.includes(key)) {
                    color = colorMapping[key];
                    break;
                }
            }
            if (color) {
                variantSpan.closest('.product-item').style.borderLeft = `solid 7px ${color}`;
            }
        });
    }

    function setColorForModName() {
        document.querySelectorAll('.col-mod-name').forEach(function (modNameDiv) {
            const modNameText = decodeHtml(modNameDiv.textContent.trim());
            let color;
            for (let key in colorMapping) {
                if (modNameText.includes(key)) {
                    color = colorMapping[key];
                    break;
                }
            }
            if (color) {
                modNameDiv.style.color = color;
            }
        });
    }

    setBorderColor();
    setColorForModName();
};